import { el, clear } from '../../core/dom.js';
import { TABS, filterCatalogue, tabCounts } from './catalogue.js';
import { cxMark } from './mark.js';
import { cxBtn, sectionError, sectionNote } from './ui.js';

function cardActions(item, onAction) {
  if (item.soon) return cxBtn('Connect', { className: 'cx-cta', disabled: true, arrow: true });
  if (!item.connected) {
    return cxBtn('Connect', { className: 'cx-cta', arrow: true, onClick: () => onAction(item, 'connect') });
  }
  const another = item.kind === 'native'
    ? cxBtn('+ Another', { onClick: () => onAction(item, 'another') })
    : null;
  return el('span', { class: 'cx-actions' },
    cxBtn('Manage', { onClick: () => onAction(item, 'manage') }),
    another);
}

function catalogueCard(item, index, onAction) {
  return el('article', {
    class: 'cx-card lift rv',
    style: `animation-delay:${(0.3 + Math.min(index, 12) * 0.04).toFixed(2)}s`,
  },
  el('div', { class: 'cx-card-top' },
    cxMark(item.name, item.title),
    el('span', { class: 'cx-card-id' },
      el('span', { class: 'cx-name' }, item.title),
      el('span', { class: 'cx-badges' },
        el('span', { class: 'cx-badge' }, item.kindLabel),
        item.badge ? el('span', { class: 'cx-badge is-dash' }, item.badge) : null)),
    item.connected ? el('span', { class: 'cx-connected' }, '✓ Connected') : null),
  el('p', { class: 'cx-desc' }, item.description),
  el('div', { class: 'cx-card-foot' },
    el('span', { class: 'cx-meta' }, item.meta),
    cardActions(item, onAction)));
}

export function fillGrid(grid, items, state, onAction) {
  clear(grid);
  const shown = filterCatalogue(items, state.tab, state.query);
  if (!shown.length) {
    const empty = state.query
      ? 'No connectors match that filter.'
      : 'Nothing in this category yet.';
    grid.append(sectionNote('Catalogue', empty));
    return;
  }
  shown.forEach((item, index) => grid.append(catalogueCard(item, index, onAction)));
}

function tabButton(id, label, count, state, onTab) {
  const on = state.tab === id;
  return el('button', {
    type: 'button',
    class: on ? 'cx-tab is-on' : 'cx-tab',
    'aria-pressed': on ? 'true' : 'false',
    'data-tab': id,
    onClick: () => onTab(id),
  }, label, el('span', { class: 'cx-tab-n' }, String(count)));
}

export function renderCatalogue(state, onTab, onQuery, onAction, onRetry) {
  if (state.providersError) {
    return el('section', { 'aria-label': 'Available connectors' },
      sectionError('Catalogue unavailable', state.providersError, onRetry));
  }
  const items = state.items || [];
  const counts = tabCounts(items);
  const grid = el('div', { class: 'cx-grid' });
  const labels = { all: 'All', Ads: 'Ads', Revenue: 'Revenue', Analytics: 'Analytics', Code: 'Code', MCP: 'MCP' };
  fillGrid(grid, items, state, onAction);
  return el('section', { id: 'cx-catalogue', class: 'cx-catalogue', 'aria-label': 'Available connectors' },
    el('div', { class: 'cx-tools rv' },
      el('span', { class: 'cx-kicker' }, `Available connectors · ${items.length}`),
      el('div', { class: 'cx-tool-row' },
        TABS.map((id) => tabButton(id, labels[id], counts[id] || 0, state, onTab)),
        el('label', { class: 'cx-filter' },
          el('span', { class: 'cx-sr' }, 'Filter connectors'),
          el('input', {
            class: 'cx-flt',
            type: 'search',
            placeholder: 'Filter…',
            value: state.query || '',
            onInput: onQuery,
          })))),
    state.mcpNote ? el('p', { class: 'cx-note' }, state.mcpNote) : null,
    grid);
}
